import React, { useState } from 'react';
import { getShebaInfo } from '@persian-tools/persian-tools';
import { Box, Typography } from '@mui/material';
import { Styled } from './bank-card-field.styled';
import { BankCardInputProps } from './types';
import { BankLogo } from '../../bank-logo/bank-logo';

const BankCardField: React.FC<BankCardInputProps> = ({
    fullname,
    subtitle,
    onChange,
    onComplete,
    ...rest
}): JSX.Element => {
    const [bank, setBank] = useState({ name: '' });
    const [iban, setIban] = useState('');

    return (
        <Styled.BankCard className="bank-card" bank={bank}>
            <Box className="card-layout">
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}>
                    {
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                visibility:
                                    iban.replace(/[\s_]/g, '')?.length !== 24
                                        ? 'hidden'
                                        : 'unset',
                            }}>
                            <BankLogo iban={iban} bankName={bank?.name} />
                        </Box>
                    }

                    <Box
                        sx={{
                            width: { xs: '24px', sm: '36px' },
                            height: { xs: '24px', sm: '36px' },
                        }}>
                        <img
                            style={{
                                width: '100%',
                                height: '100%',
                                transform: 'translate(0px,-1px)',
                            }}
                            src={'/images/shetab.svg'}
                            alt=""
                        />
                    </Box>
                </Box>

                <Box sx={{ width: '100%', textAlign: 'center' }}>
                    <Typography className="card-name">{fullname}</Typography>
                    {subtitle && (
                        <Typography
                            className="card-subtitle"
                            sx={{
                                mt: 0.35,
                                width: '100%',
                                display: 'block',
                                textAlign: 'center !important',
                                direction: 'rtl',
                                color: 'inherit',
                                opacity: 0.88,
                                fontSize: { xs: '0.68rem', sm: '0.76rem' },
                                lineHeight: 1.6,
                            }}>
                            {subtitle}
                        </Typography>
                    )}
                </Box>

                <Styled.ShebaField
                    {...rest}
                    onChange={(value: string) => {
                        setIban(value);

                        const sheba = getShebaInfo(
                            'IR' + value.replaceAll(' ', ''),
                        );

                        setBank({
                            name:
                                sheba && sheba.persianName
                                    ? sheba.persianName?.replace(/^بانک\s*/, '')
                                    : '',
                        });

                        if (onChange) onChange(value);
                        if (onComplete && sheba && sheba.persianName)
                            onComplete(value);
                    }}
                />
            </Box>
        </Styled.BankCard>
    );
};

export { BankCardField };
export type { BankCardInputProps };
